import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "新闻", to: "/category/news" },
  { label: "作品", to: "/works" },
  { label: "个人资料", to: "/profile" },
  { label: "关于", to: "/about" },
];

export default function SiteNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/category/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-star-smile-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
                小泽玛利亚
              </span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-500 uppercase">
                Maria Ozawa
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "text-primary-700 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <form
              onSubmit={handleSearch}
              className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2 focus-within:border-primary-300 transition-colors"
            >
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯或作品"
                className="bg-transparent outline-none text-sm w-40 text-foreground-800 placeholder:text-foreground-400"
              />
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div ref={menuRef} className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 flex flex-col gap-1">
            <form
              onSubmit={handleSearch}
              className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2 mb-3"
            >
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯或作品"
                className="bg-transparent outline-none text-sm flex-1 text-foreground-800 placeholder:text-foreground-400"
              />
            </form>
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-3 rounded-md text-sm whitespace-nowrap ${
                  isActive(item.to)
                    ? "text-primary-700 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}